import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, ReactiveFormsModule} from '@angular/forms';
import {TranslationService} from '@emma-labs/shared/angular';
import {ENVIRONMENT, EnvironmentBroker} from '@emma-labs/shared/typescript';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CardModule} from 'primeng/card';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {debounceTime} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';
import {DEBOUNCE_TIME} from '../../../utils/utility-constants';
import {BaseSectionComponent} from '../../base-section/base-section.component';

@UntilDestroy()
@Component({
  selector: 'em-note-section',
  templateUrl: './note-section.component.html',
  imports: [CardModule, ReactiveFormsModule, InputTextareaModule],
})
export class NoteSectionComponent extends BaseSectionComponent<FormControl<string | null>, string> {
  constructor(
    readonly translate: TranslationService,
    private readonly fb: FormBuilder,
    @Inject(ENVIRONMENT) environment: EnvironmentBroker,
  ) {
    super(environment);
    this.form = this.createForm();
  }

  private createForm(): FormControl<string | null> {
    const form = this.fb.control<string | null>(null);

    form.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(DEBOUNCE_TIME), untilDestroyed(this))
      .subscribe((value) => this.propsChange.emit({output: value ?? ''}));

    return form;
  }
}
